import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { storesApi } from "../../api";
import { IArticles } from "../types";



type ArticlesState = {
    loading: boolean
    error: null | string
    articles: null | IArticles[]
}

const initialState: ArticlesState = {
    error: null,
    loading: false,
    articles: null,
}


export const fetchByArticles = createAsyncThunk(
    'articles/fetchByArticles',
    async (_, { rejectWithValue }) => {
        try {
        const res = await storesApi.getArticles()
               return res.data.data;
            } catch (error: any) {
               return rejectWithValue(error.response?.data || 'Ошибка сервера');
           }
     
    })





const infoSlice = createSlice({
    name: 'articles',
    initialState,
    reducers: {},
    extraReducers: ({ addCase }) => {
        addCase(fetchByArticles.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        addCase(fetchByArticles.fulfilled, (state, action) => {
            state.articles = action.payload;
            state.loading = false;
        });
        addCase(fetchByArticles.rejected, (state) => {
            state.loading = false;
            state.error = 'Ошибка сервера!';
        });

    },
})


export default infoSlice.reducer





